import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useParams } from "react-router-dom";
import { isEmpty } from "lodash";
import { toast } from "react-toastify";
import {
  SECTION_NEWS_COMPONENTS,
  STD_ERROR_MESSAGE,
} from "../../../../utils/constant.js";
import { fetchNews } from "../../../../services/news.service";
import News from "../../news/News.jsx";
import AddNews from "../../add-news/AddNews.js";

const SectionNews = (props) => {
  const [loading, setLoading] = useState(true);
  const newsState = useSelector((state) => state.newsAd);
  const dispatch = useDispatch();
  const params = useParams();

  const [currentMainComponent, setCurrentMainComponent] = useState({
    currComponent: null,
    prevComponent: null,
  });
  useEffect(() => {
    if (isEmpty(newsState.response)) {
      dispatch(fetchNews(params.collectionId));
    }
  }, []);

  useEffect(() => {
    if (!newsState.loading && !isEmpty(newsState.response)) {
      if (!isEmpty(newsState.response.data)) {
        setCurrentMainComponent((prevState) => {
          return {
            currComponent: SECTION_NEWS_COMPONENTS.list_news_sections,
            prevComponent: prevState.component,
          };
        });
      } else {
        setCurrentMainComponent((prevState) => {
          return {
            currComponent: SECTION_NEWS_COMPONENTS.add_news_sections,
            prevComponent: prevState.component,
          };
        });
      }
      setLoading(false);
    }
    if (!newsState.loading && !isEmpty(newsState.error)) {
      setLoading(false);
      toast.error(newsState.error?.data?.error_data || STD_ERROR_MESSAGE);
    }
  }, [newsState]);

  function getMainComponent() {
    switch (currentMainComponent.currComponent) {
      case SECTION_NEWS_COMPONENTS.add_news_sections:
        return (
          <AddNews
            setCurrentMainComponent={setCurrentMainComponent}
            currentMainComponent={currentMainComponent}
          />
        );
      case SECTION_NEWS_COMPONENTS.list_news_sections:
        return (
          <News
            setCurrentMainComponent={setCurrentMainComponent}
            currentMainComponent={currentMainComponent}
          />
        );
      default:
        return null;
    }
  }
  return <>{!loading ? getMainComponent() : null}</>;
};
export default SectionNews;
